import Loader from '~components/generic/loader/Loader';
import { SearchResultHeader } from '~components/search/SearchResultHeader';
import { SearchResultList } from '~components/search/SearchResultList';
import { LoadingError } from '~modules/media-library/view/LoadingError';

type BrandguideResultsProps = {
  resultList: SearchResultsItem[];
  isLoading: boolean;
  isError?: boolean;
  numFound?: number;
  onLoadMore?: () => void;
};

export function BrandguideResults({
  resultList,
  isLoading,
  isError = false,
  numFound = 0,
  onLoadMore,
}: BrandguideResultsProps) {
  return (
    <div className="emb--search-view bg-gray w-full min-h-screen px-3">
      {isError || isLoading ? (
        <div className="absolute inset-0 flex items-center justify-center">
          {isError && <LoadingError />}
          {isLoading && (
            <div className="relative w-16 h-8">
              <Loader absoluteCenter={true} />
            </div>
          )}
        </div>
      ) : (
        <>
          <SearchResultHeader isLoading={isLoading} numFound={numFound} />
          <SearchResultList numFound={numFound} resultList={resultList} onLoadMore={onLoadMore} />
        </>
      )}
    </div>
  );
}
